<div [ngClass]="{open: isEditing}" class="dashboard padding">
  <div class="row widgets-container" #widgetsContainer (dragenter)="onWidgetBoardDrag()">
    <div *ngIf="isAllClosed" class="no-widgets on-drag">
      <gp-message type="info">
        <span>{{ 'DASHBOARD.no_widgets_start' | translate }}&nbsp;</span>
        <i class="fa fa-light fa-cog"></i>
        <span>&nbsp;{{ 'DASHBOARD.no_widgets_end' | translate }}</span>
      </gp-message>
    </div>
    <ng-container *ngFor="let box of boxes">
      <div [attr.data-card-type]="box.cardType"
           [attr.data-hidden]="box.isClosed"
           class="col-xs-12 col-sm-6 col-md-6 col-lg-4 on-drag">
        <div class="box shadow draggable"
             draggable="true"
             (dragstart)="onDragStart($event, box)"
             (dragenter)="onDragEnter($event)"
             (dragend)="onDragEnd()"
             (drag)="onDrag($event)">
          <div class="box-header">
            <h3>{{ box.title | translate }}
              <i class="fa fa-circle-info m-l-xs"
                 tooltip="{{box.description | translate}}"
                 placement="bottom"
                 containerClass="tooltip-widget"
                 [container]="'body'">
              </i>
            </h3>
          </div>
          <div class="box-tool">
            <ul class="nav">
              <li class="nav-item inline" *ngIf="!box.notification">
                <a class="nav-link" (click)="refreshChart(box)">
                  <i class="fa-solid fa-rotate"></i>
                </a>
              </li>
              <li class="nav-item inline m-l-sm" *ngIf="isEditing">
                <a class="nav-link" (click)="deleteCard(box)">
                  <i class="fa-solid fa-xmark"></i>
                </a>
              </li>
            </ul>
          </div>
          <ng-container *ngIf="!box.isLoading">
            <!--CHART CARD-->
            <ng-container *ngIf="box.chart">
              <div class="box-body">
                <!-- Add this dropdown above each chart -->
                <div class="regulation-filter"
                     *ngIf="box.chart.data?.length && box.cardType === 'GROSS_SALARY_PER_REGULATION'">
                  <div>
                    <label for="regulation-select">{{ 'COMMON.regulation' | translate }}:</label><br/>
                    <select
                      id="regulation-select"
                      [value]="box.selectedRegulation"
                      (change)="onRegulationChange($event, box)">
                      <option *ngFor="let regulation of getRegulationsForChart(box)"
                              [value]="regulation"
                              [selected]="regulation === box.selectedRegulation">
                        {{ regulation }}
                      </option>
                    </select>
                  </div>
                  <div class="p-t-sm">
                    <h4 class="pull-right text-muted">{{ box.currentMonthGrossSalary }}
                      ({{ 'DASHBOARD.latest_month' | translate }})</h4>
                  </div>
                </div>

                <gp-echart *ngIf="box.chart.data?.length"
                           [height]="'350px'"
                           [width]="'100%'"
                           [options]="box.chart.chartConfig"
                           (datumClick)="onChartClick($event, box.title)">
                </gp-echart>
                <div class="p-a-md" *ngIf="!box.chart.data?.length">
                  <gp-message text="COMMON.no_chart_data" type="info"></gp-message>
                </div>
              </div>
            </ng-container>
            <!--NOTIFICATION CARD-->
            <ng-container *ngIf="box.notification">
              <div class="box-body" style="overflow: auto">
                <gp-communications-card></gp-communications-card>
              </div>
            </ng-container>
            <!--POSITION CARD-->
            <ng-container *ngIf="box.position">
              <div class="box-body" style="overflow: auto">
                <gp-positions-card [data]="box.position"
                                   (selected)="onChartClick($event, box.title)"></gp-positions-card>
              </div>
            </ng-container>
            <!--PROGRESS CARD-->
            <ng-container *ngIf="box.progress">
              <div class="box-body" style="overflow: auto">
                <gp-progress-card [data]="box.progress"
                                  (selected)="onChartClick($event, box.title)"></gp-progress-card>
              </div>
            </ng-container>
          </ng-container>
          <div class="p-a-md padding text-center" *ngIf="box.isLoading">
            <i class="fa fa-light fa-spinner fa-spin"></i>
          </div>
        </div>
      </div>
    </ng-container>
  </div>
  <!--CONFIG PANEL-->
  <div *ngIf="isEditing" class="edit-panel">
    <ng-container *ngFor="let box of boxes">
      <div [attr.data-hidden]="!box.isClosed">
        <div class="box shadow draggable"
             [class.fake-data-card]="box.isFake"
             draggable="true"
             (dragstart)="onDragStart($event, box)"
             (dragend)="onDragEnd()">
          <div class="box-header">
            <h3>{{ box.title | translate }}</h3>
            <span *ngIf="box.isFake"
                  class="preview-badge"
                  tooltip="{{ 'DASHBOARD.fake_data_info' | translate }}"
                  placement="bottom"
                  [containerClass]="'tooltip-widget'"
                  [container]="'body'">
              <i class="fa fa-circle-info m-r-xs"></i>{{ 'DASHBOARD.fake_data' | translate }}
            </span>
          </div>
          <!--CHART CARD-->
          <ng-container *ngIf="box.chart">
            <div class="box-body">
              <div class="regulation-filter"
                   *ngIf="box.chart.data?.length && box.cardType === 'GROSS_SALARY_PER_REGULATION'">
                <label for="regulation-select">{{ 'COMMON.regulation' | translate }}:</label><br/>
                <select
                  id="regulation-select-edit"
                  [value]="box.selectedRegulation"
                  (change)="onRegulationChange($event, box)">
                  <option *ngFor="let regulation of getRegulationsForChart(box)"
                          [value]="regulation"
                          [selected]="regulation === box.selectedRegulation">
                    {{ regulation }}
                  </option>
                </select>
                <h2 class="pull-right ">({{ 'DASHBOARD.latest_month' | translate }})</h2>
              </div>
              <gp-echart *ngIf="box.chart.data?.length"
                         [height]="'300px'"
                         [width]="'100%'"
                         [options]="box.chart.chartConfig">
              </gp-echart>
              <div class="p-a-md" *ngIf="!box.chart.data?.length">
                <gp-message text="COMMON.no_chart_data" type="info"></gp-message>
              </div>
            </div>
          </ng-container>
          <!--NOTIFICATION CARD-->
          <ng-container *ngIf="box.notification">
            <div class="box-body" style="overflow: auto">
              <gp-communications-card></gp-communications-card>
            </div>
          </ng-container>
          <!--POSITION CARD-->
          <ng-container *ngIf="box.position">
            <div class="box-body" style="overflow: auto">
              <gp-positions-card [data]="box.position"></gp-positions-card>
            </div>
          </ng-container>
          <!--PROGRESS CARD-->
          <ng-container *ngIf="box.progress">
            <div class="box-body" style="overflow: auto">
              <gp-progress-card [data]="box.progress"></gp-progress-card>
            </div>
          </ng-container>
        </div>
      </div>
    </ng-container>
    <div *ngIf="isAllOpened && !isEditPanelLoaded">
      <gp-message text="DASHBOARD.no_available_widgets" type="info"></gp-message>
    </div>
    <div class="p-a-md padding text-center" *ngIf="isEditPanelLoaded">
      <i class="fa fa-light fa-spinner fa-spin"></i>
    </div>
  </div>
  <div [ngClass]="{open: isEditing}"
       class="edit-button"
       (click)="toggleEditPanel()"
       tooltip="{{ 'DASHBOARD.edit_config_panel' | translate }}"
       placement="bottom">
    <i *ngIf="!isEditing" class="fa fa-light fa-cog"></i>
    <i *ngIf="isEditing" class="fa fa-light fa-times"></i>
  </div>
</div>

